/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize ProteinEnergeticWear View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ProteinEnergeticWearView';

export const mapStateToPropsProteinEnergeticWear = mapStateToProps;
export const mapDispatchToPropsProteinEnergeticWear = mapDispatchToProps;

export default connect(
  mapStateToPropsProteinEnergeticWear,
  mapDispatchToPropsProteinEnergeticWear
)(View);
